import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-width": "4"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m2 2 8 8M2 10l8-8" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }